'use strict'
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault')
require('core-js/modules/es.array.filter')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.includes')
require('core-js/modules/es.array.index-of')
require('core-js/modules/es.string.includes')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = setTimePartToStartEnd

var _is = require('../is')
var _convert = _interopRequireDefault(require('./convert'))
var _consts = require('./consts')
var _getters = require('./getters')
var _setters = require('./setters')
var _utils = require('./utils')

function getKeysToChange(ind) {
  if (ind === -1) return []
  return _consts.objDateKeys.filter(function(name, i) {
    return i > ind
  })
}

function getPartsVal(keysToChange, startOrEnd) {
  var parts = {}
  if (startOrEnd === 'start') {
    keysToChange.forEach(function(name) {
      parts[name] = name === 'd' ? 1 : 0
    })
  } else {
    keysToChange.forEach(function(name) {
      parts[name] = _consts.maxPartVals[name]
    })
  }

  return parts
}

function setWeekStartEnd(d, startOrEnd) {
  var weekDay = (0, _getters.get)(d, 'D')
  var dateDay = (0, _getters.get)(d, 'd')

  var newDateDay =
    startOrEnd === 'start'
      ? dateDay - weekDay + 1 // +1 for move first day to Monday
      : dateDay + (7 - weekDay)

  // eslint-disable-next-line no-use-before-define
  var date = setTimePartToStartEnd(d, 'd', startOrEnd)

  if (weekDay === 0 && startOrEnd === 'end') {
    return date
  }

  ;(0, _setters.set)(date, 'd', newDateDay)
  return date
}

function setQuarterStartEnd(d, startOrEnd) {
  var q = (0, _getters.get)(d, 'q')
  var M = 0 + q * 3 + (startOrEnd === 'end' ? 2 : 0)
  ;(0, _setters.set)(d, 'd', 15)
  ;(0, _setters.set)(d, 'M', M)

  // eslint-disable-next-line no-use-before-define
  return setTimePartToStartEnd(d, 'M', startOrEnd)
}

function setTimePartToStartEnd(d, partName, startOrEnd) {
  var name = partName === 'D' ? 'd' : partName
  if (name === 'w') {
    return setWeekStartEnd(d, startOrEnd)
  }
  if (name === 'q') {
    return setQuarterStartEnd(d, startOrEnd)
  }
  var indOfPartName = _consts.objDateKeys.indexOf(name)
  if (indOfPartName === -1) {
    console.error('wrond time part name', partName)
    return d
  }

  var keysToChange = getKeysToChange(indOfPartName)

  var parts = getPartsVal(keysToChange, startOrEnd)

  var resultDate = _convert.default.fromObj(parts, d)

  if ((0, _is.isNull)(resultDate)) return d

  if (startOrEnd === 'end') {
    var neededMonth = keysToChange.includes('M') ? parts.M : (0, _getters.get)(d, 'M')
    var resultMonth = (0, _getters.get)(resultDate, 'M')
    if (neededMonth !== resultMonth) {
      ;(0, _setters.set)(resultDate, 'M', neededMonth)
      ;(0, _setters.set)(resultDate, 'd', (0, _utils.getLastDateInMonth)(resultDate))
    }
  }

  return resultDate
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/Time/setTimePartToStartEnd.js
// module id = 221
// module chunks = 0